import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { updatePosShop } from "../../core/retailShop.core";
import { useTranslation } from "../../core/translation.core";
import useRetailShop from "../../hooks/useRetailShop";
import { RetailShopFormData } from "../../types/retailShop";
import { FancyCheckbox } from "../reuseables/checkbox.comp";

export default function ProfilePaymentOptions() {
  const shop = useRetailShop();
  const { register, reset, handleSubmit } = useForm();

  const update = useMutation({
    //  @ts-ignore
    mutationFn: (data: RetailShopFormData) => updatePosShop(shop.id, data),
    onError: (err: any) => {
      toast.error(err.message);
    },
    onSuccess: (res: any) => {
      toast.success(res.message);
      queryClient.invalidateQueries({ queryKey: ["retailShopId"] });
    },
  });

  const queryClient = useQueryClient();

  const { t, msg } = useTranslation();

  useEffect(() => {
    if (!shop) return;

    reset({
      paymentOptions: shop.paymentOptions,
    });
  }, [shop, reset]);

  function onSubmit(data) {
    update.mutate(data);
  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="dark:text-white grid grid-cols-[200px_auto]">
          <div>{t(msg.pos.paymentOptions)} </div>

          <div>
            <FancyCheckbox value="cash" register={register("paymentOptions")} labelId="label-cash">
              {t(msg.pos.cash)}
            </FancyCheckbox>

            <FancyCheckbox value="visa" register={register("paymentOptions")} labelId="label-visa">
              {t(msg.pos.visa)}
            </FancyCheckbox>

            <FancyCheckbox value="mastercard" register={register("paymentOptions")} labelId="label-mastercard">
              {t(msg.pos.masterCard)}
            </FancyCheckbox>

            <FancyCheckbox value="paypal" register={register("paymentOptions")} labelId="label-paypal">
              {t(msg.pos.paypal)}
            </FancyCheckbox>

            <FancyCheckbox value="alipay" register={register("paymentOptions")} labelId="label-alipay">
              {t(msg.pos.alipay)}
            </FancyCheckbox>

            <FancyCheckbox value="wechatpay" register={register("paymentOptions")} labelId="label-wechatpay">
              {t(msg.pos.wechat)}
            </FancyCheckbox>

            <FancyCheckbox value="payme" register={register("paymentOptions")} labelId="label-payme">
              {t(msg.pos.payme)}
            </FancyCheckbox>

            <FancyCheckbox value="fps" register={register("paymentOptions")} labelId="label-fps">
              {t(msg.pos.fps)}
            </FancyCheckbox>

            <FancyCheckbox value="octopus" register={register("paymentOptions")} labelId="label-octopus">
              {t(msg.pos.octopus)}
            </FancyCheckbox>

            <FancyCheckbox value="unionPay" register={register("paymentOptions")} labelId="label-unionPay">
              {t(msg.pos.unionPay)}
            </FancyCheckbox>

            <FancyCheckbox value="applePay" register={register("paymentOptions")} labelId="label-applePay">
              {t(msg.pos.applePay)}
            </FancyCheckbox>

            <FancyCheckbox value="samsungPay" register={register("paymentOptions")} labelId="label-samsungPay">
              {t(msg.pos.samsungPay)}
            </FancyCheckbox>

            <FancyCheckbox value="googlePay" register={register("paymentOptions")} labelId="label-googlePay">
              {t(msg.pos.googlePay)}
            </FancyCheckbox>

            <FancyCheckbox value="hcv" register={register("paymentOptions")} labelId="label-hcp">
              {t(msg.pos.hcv)}
            </FancyCheckbox>
          </div>
        </div>

        <input type="submit" value={t(msg.pos.save)} className="w-fit px-2 py-1" />
      </form>
    </div>
  );
}
